import { render, staticRenderFns } from "./ImagesBlank.vue?vue&type=template&id=52f6a7e4"
import script from "./ImagesBlank.vue?vue&type=script&lang=js"
export * from "./ImagesBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports